<div
  class="splash-overlay"
  *ngIf="showSplash"
  [class.is-closing]="isSplashClosing"
>
  <div class="splash-overlay__backdrop"></div>

  <div class="splash-overlay__content">
    <div class="splash-badge">Admissions Open</div>

<div class="splash-logo-wrap">
  <span class="spark spark-1"></span>
  <span class="spark spark-2"></span>
  <span class="spark spark-3"></span>
  <span class="spark spark-4"></span>
  <div class="logo-glow"></div>
  <img class="splash-logo" src="assets/img/logo.png" alt="College Logo" />
</div>

    <h1 class="splash-title">
      <span class="title-white">Admission</span>
      <span class="title-gold">2026</span>
    </h1>

    <p class="splash-subtitle" *ngIf="!showThankYou; else closingMessage">
      Welcome to Fatima Michael College of Engineering &amp; Technology
    </p>

    <ng-template #closingMessage>
      <p class="splash-subtitle splash-thanks">
        Thank you !
      </p>
    </ng-template>

    <div class="splash-meta">
      <div class="meta-item">
        <span class="meta-label">Counselling Code</span>
        <span class="meta-value code-white">5935</span>
      </div>

      <div class="meta-item">
        <span class="meta-label">Apply Now</span>
        <span class="meta-value gold-value">Open for UG / PG</span>
      </div>
    </div>

    <div class="splash-progress" *ngIf="!showThankYou">
      <span class="splash-progress__bar"></span>
    </div>

    <button
      type="button"
      class="skip-btn"
      *ngIf="!showThankYou"
      (click)="closeSplash()"
    >
      Skip Intro
    </button>
  </div>
</div>

<div class="home-nine-page" [class.is-locked]="showSplash">
  <app-header-style-seven></app-header-style-seven>

  <section class="page-shell home-nine-shell">
    <div class="custom-container">
      <div class="content-shell home-nine-shell-card">
        <section class="section-shell is-tight banner-shell">
          <app-homenine-main-banner></app-homenine-main-banner>
        </section>

        <section class="section-shell">
          <app-get-started></app-get-started>
        </section>

        <section class="section-shell">
          <app-features-stye-three></app-features-stye-three>
        </section>

        <section class="section-shell testimonials-wrap-area testimonials-wrap-shell">
          <app-students-feedback></app-students-feedback>
        </section>
      </div>
    </div>
  </section>
</div>